<template>
  <div>
    <h2 class="text-truncate font-weight-bold text-h5 mb-4">{{$t('Subscriptions')}}</h2>
    <div
        v-if="(subscriptions && !subscriptions.length) && !isLoading"
        class="pa-3 d-flex align-center"
    >
        <v-icon>mdi-list-box-outline</v-icon>
        <p class="mb-0 ml-2 text-subtitle-1">
            {{ $t('You do not have any subscriptions') }}.
        </p>
    </div>

    <template v-if="subscriptions && subscriptions.length">
        <subscriptions-in-table
            :subscriptions="subscriptions"
            @cancel="openCancelModal"
        />
        <pagination
            :resource="pagination"
            :overwrite-path="url"
            @load="load"
        />
    </template>

    <cancel-subscription
        ref="cancelReservation"
        @cancelled="subscriptionCancelled"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { fullDateFormat } from '@/components/calendar/config';
import Pagination from '@/components/Pagination.vue';
import SubscriptionsInTable from '@/components/subscriptions/SubscriptionsInTable.vue';
import SubscriptionsMixin from '@/lib/SubscriptionsMixin';
import CancelSubscription from '@/components/subscriptions/CancelSubscription.vue';

export default {
  components: { Pagination, SubscriptionsInTable, CancelSubscription },
  mixins: [SubscriptionsMixin],
  data() {
    return {
      subscriptions: [],
      pagination: {},
      url: '/subscriptions',
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    ...mapGetters(['loading']),
    isLoading() {
      return this.$store.getters.loading;
    },
  },
  methods: {
    fullDateFormat,
    load(url = this.url) {
      this.$store.dispatch('loading', true);
      axios
        .get(url)
        .then(({ data }) => {
          this.pagination = data;
          this.subscriptions = data.data && data.data.length ? data.data : data;
          this.$store.dispatch('loading', false);
          this.$nextTick(() => {
            this.$store.dispatch('startBusinessBillingGuideFlow', {
              routeName: this.$route.name,
              router: this.$router,
            });
          });
        })
        .catch(() => {
          this.$store.dispatch('loading', false);
        });
    },
    subscriptionCancelled() {
      setTimeout(() => {
        this.load();
      }, 1000);
    },
    openCancelModal(id) {
      const subscription = this.subscriptions.find((s) => s.id === id);
      if (subscription) {
        this.$refs.cancelReservation.open(subscription);
      }
    },
  },
};
</script>
